import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import styled from 'styled-components';

import { DatePicker } from 'components/styled-primitives';
import { Label, InputContainer, MultiInputContainer } from '../../components';

const DatesContainer = styled.div`
  display: flex;
  align-items: center;

  p {
    margin: 0 7px 0.3em;
  }
`;

const HiddenDatePicker = styled(DatePicker).attrs({
  readOnly: true,
})`
  &&&&& button {
    border: 0;
  }
`;

interface BillingPeriodManagerProps {
  licenseStartDate?: Date | null;
  licenseEndDate?: Date | null;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
}

const BillingPeriodManager = ({
  licenseStartDate,
  onStartDateChange,
  onEndDateChange,
  licenseEndDate,
}: BillingPeriodManagerProps): React.JSX.Element => (
  <MultiInputContainer>
    <InputContainer>
      <Label>Billing Period</Label>
      <DatesContainer>
        <DatePicker
          selected={licenseStartDate}
          onChange={onStartDateChange}
          dataTestId="billing-period-start-date"
          time={DatePicker.START_OF_DAY}
        />
        <p>to</p>
        <DatePicker
          selected={licenseEndDate || null}
          onChange={onEndDateChange}
          dataTestId="billing-period-end-date"
          time={DatePicker.END_OF_DAY}
        />
      </DatesContainer>
    </InputContainer>
    <InputContainer>
      <Label>Next Billing Date</Label>
      <HiddenDatePicker selected={licenseEndDate} dataTestId="billint-period-next-billing-date" />
    </InputContainer>
  </MultiInputContainer>
);

export default BillingPeriodManager;
